import {create} from 'zustand';
import {UseExitFlowSidebarRouteStoreProps} from './types';

export const useExitFlowSidebarRouteStore = create<UseExitFlowSidebarRouteStoreProps>(set => ({
	route: undefined,
	setRoute: route => set({route}),
	reset: () => set({route: undefined}),
}));
